import React, { FC } from 'react';
import { View } from 'react-native';

import { ContainerStyle } from '@interfaces/base';

export interface DashboardDrilldownTrendProps extends ContainerStyle {}

const DashboardDrilldownTrend: FC<DashboardDrilldownTrendProps> = ({ containerStyle }) => {
  return <View style={[{ flex: 1 }, containerStyle]} />;
};

export default DashboardDrilldownTrend;
